import { ILookupResult } from '../../shared-types';

interface IMenuHistoryCacheEntry {
  items: ILookupResult[];
}

interface IMenuHistoryCacheOptions {
  keySuffix?: string;
  keyPrefix?: string;
}

export default class MenuHistoryCache {
  private options: IMenuHistoryCacheOptions = {
    keySuffix: '',
    keyPrefix: '.mhc_',
  };
  public constructor(options: IMenuHistoryCacheOptions) {
    Object.assign(this.options, options);
  }

  public get(): ILookupResult[] {
    return findMenuHistoryCacheEntry(this.makeKey()) || [];
  }

  public set(items: ILookupResult[]) {
    const itemsToStore = items.map((item) => {
      // eslint-disable-next-line id-blacklist
      item.lastUsed = item.lastUsed === undefined ? null : item.lastUsed;
      return item;
    });
    cacheMenuHistoryResults(this.makeKey(), itemsToStore);
  }

  public flush() {
    const key = this.makeKey();
    Object.keys(localStorage)
      .filter((s) => s === key)
      .forEach((s) => {
        localStorage.removeItem(s);
      });
  }

  private makeKey() {
    const { keyPrefix, keySuffix } = this.options;
    return `${keyPrefix}_${keySuffix}`;
  }
}

export function tryParseMenuHistoryCacheEntry(
  cacheEntryJson: string
): IMenuHistoryCacheEntry | null {
  try {
    return JSON.parse(cacheEntryJson);
  } catch {
    return null;
  }
}

export function findMenuHistoryCacheEntry(key: string): ILookupResult[] | null {
  const cachedJson = localStorage.getItem(key);
  if (!cachedJson) {return null;}
  const cachedEntry = tryParseMenuHistoryCacheEntry(cachedJson);
  if (!cachedEntry) {return null;}

  return cachedEntry.items;
}

export function cacheMenuHistoryResults(key: string, items: ILookupResult[]) {
  const cacheEntry: IMenuHistoryCacheEntry = { items };

  localStorage.setItem(key, JSON.stringify(cacheEntry));
}
